/**
 * New arrivals - thumbnail strip switches which product is in the spotlight.
 *
 * The markup for every product is already on the page; this only toggles
 * which panel is visible. Nothing is fetched and nothing is rebuilt, so the
 * section works from the first paint and degrades to the first product if
 * this script never runs.
 */
(() => {
  const init = (root) => {
    if (root.dataset.ctNa === 'done') return;

    const tabs = [...root.querySelectorAll('.ct-na__thumb')];
    const panels = [...root.querySelectorAll('.ct-na__panel')];
    const strip = root.querySelector('.ct-na__strip');
    const prev = root.querySelector('.ct-na__arrow--prev');
    const next = root.querySelector('.ct-na__arrow--next');
    if (tabs.length === 0 || panels.length === 0) return;

    const last = tabs.length - 1;
    let current = 0;

    const show = (i, moveFocus) => {
      const at = Math.min(Math.max(i, 0), last);
      current = at;

      panels.forEach((panel, n) => {
        panel.hidden = n !== at;
      });
      tabs.forEach((tab, n) => {
        const on = n === at;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
      });

      const tab = tabs[at];
      if (tab && strip) {
        // Keep the chosen thumbnail in view without scrolling the page itself.
        const box = strip.getBoundingClientRect();
        const own = tab.getBoundingClientRect();
        if (own.left < box.left || own.right > box.right) {
          strip.scrollTo({
            left: tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2,
            behavior: 'smooth',
          });
        }
      }
      if (moveFocus && tab) tab.focus();

      if (prev) prev.disabled = at === 0;
      if (next) next.disabled = at === last;
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => show(i, false));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { show(i + 1, true); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(i - 1, true); e.preventDefault(); }
        if (e.key === 'Home') { show(0, true); e.preventDefault(); }
        if (e.key === 'End') { show(last, true); e.preventDefault(); }
      });
    });

    prev?.addEventListener('click', () => show(current - 1, false));
    next?.addEventListener('click', () => show(current + 1, false));

    show(0, false);
    root.dataset.ctNa = 'done';
  };

  const boot = () => document.querySelectorAll('.ct-na').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
